import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=c685562a&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=c685562a&prod&scoped=true&lang=css"
import style1 from "./UserLayout.vue?vue&type=style&index=1&id=c685562a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c685562a",
  null
  
)

export default component.exports